export const adaptivePlannerQueryKeys = {
  backlogItems: {
    all: ({ planId }: { planId: number }) => ['backlogItems', planId],
    detail: ({ planId, itemId }: { planId?: number; itemId: number }) => [
      'backlogItems',
      planId,
      'detail',
      itemId,
    ],
    dataSet: ({ planId, filters }: { planId: number; filters?: unknown }) => [
      'dataSet',
      'backlogItems',
      planId,
      filters,
    ],
    dataSetAll: ({ planId }: { planId: number }) => ['dataSet', 'backlogItems', planId],
    dataSetsByPlanIds: ({ planIds }: { planIds: number[] }) => [
      'dataSets',
      'backlogItems',
      planIds,
    ],
    assignedTeamIds: ({ planId }: { planId: number }) => [
      'assignedTeamIds',
      'backlogItems',
      planId,
    ],
    count: ({ planId, filters }: { planId: number; filters?: unknown }) => [
      'count',
      'backlogItems',
      planId,
      filters,
    ],
    countAll: ({ planId }: { planId: number }) => ['count', 'backlogItems', planId],
  },
  plans: {
    all: () => ['plans'],
    detail: ({ planId }: { planId: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'detail',
      planId,
    ],
    owners: ({ planIds }: { planIds?: number[] }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'owners',
      planIds,
    ],
    owner: ({ planId }: { planId?: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'owner',
      planId,
    ],
    usersPermissions: ({ planId }: { planId?: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'userPermissions',
      planId,
    ],
    permissions: ({ planIds }: { planIds?: number[] }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'permissions',
      planIds,
    ],
    permission: ({ planId }: { planId?: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'permission',
      planId,
    ],
    alerts: ({ planId, alertTypes }: { planId: number; alertTypes?: string[] }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'alerts',
      planId,
      alertTypes,
    ],
    name: ({ planId }: { planId: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'name',
      planId,
    ],
    names: ({ planIds }: { planIds: number[] }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'names',
      planIds,
    ],
  },
  scenarios: {
    scenarioGenerationStatus: {
      all: ({ planId }: { planId: number }) => ['scenarios', 'scenarioGenerationStatus', planId],
      detail: ({ planId, scenarioId }: { planId?: number; scenarioId?: number }) => [
        'scenarios',
        'scenarioGenerationStatus',
        planId,
        scenarioId,
      ],
    },
    dataset: ({ planId }: { planId: number }) => ['scenarios', 'dataset', planId],
    all: ({ planId }: { planId: number }) => ['scenarios', planId],
    detail: ({ scenarioId, planId }: { scenarioId: number; planId: number }) => [
      ...adaptivePlannerQueryKeys.scenarios.all({ planId }),
      'detail',
      scenarioId,
    ],
    lastPublishResult: ({ scenarioId, planId }: { scenarioId: number; planId: number }) => [
      ...adaptivePlannerQueryKeys.scenarios.all({ planId }),
      'lastPublishResult',
      scenarioId,
    ],
    validatePublish: ({ scenarioId, planId }: { scenarioId: number; planId: number }) => [
      ...adaptivePlannerQueryKeys.scenarios.all({ planId }),
      'validatePublish',
      scenarioId,
    ],
  },
  scenarioItems: {
    detail: ({
      planId,
      scenarioId,
      itemId,
    }: {
      planId?: number;
      scenarioId?: number;
      itemId?: number;
    }) => ['scenarioItems', planId, scenarioId, 'detail', itemId],
  },
  timeline: {
    dataSet: ({ planId, scenarioId }: { planId: number; scenarioId: number }) => [
      'timeline',
      'dataSet',
      planId,
      scenarioId,
    ],
    bulkFetch: ({ planId, scenarioId }: { planId: number; scenarioId: number }) => [
      'timeline',
      'bulkFetch',
      planId,
      scenarioId,
    ],
    detail: ({
      planId,
      scenarioId,
      itemId,
    }: {
      planId: number;
      scenarioId: number;
      itemId: number;
    }) => ['timeline', 'detail', planId, scenarioId, itemId],
  },
  virtualResources: {
    planVirtualResources: ({ planId }: { planId: number }) => ['virtualResources', planId],
  },
};
